import { takeLatest } from "redux-saga/effects";
import { getMembershipPlans } from "../../StateManagement/Reducers/MembershipState";
import { MembershipPlansWorker } from "./MembershipSagaWorkers";

export function* MembershipSagaWatcher() {
  yield takeLatest(getMembershipPlans.type, MembershipPlansWorker);
}
